import { Link } from "react-router-dom";
import { PackageCatalog } from "../models/PackageCatalog.js";

const catalog = PackageCatalog.launch();

export function PackagesPage() {
  return (
    <section className="t-packages-page" data-page="packages">
      <header className="t-highlights-head">
        <p className="t-kicker">Packages</p>
        <h1 className="t-section-title">Simple per-product pricing</h1>
        <p className="t-section-lead">
          These are launch prices in USD and may change. Your quote confirms the final amount before
          work starts. Rush delivery adds 25 percent.
        </p>
      </header>
      <div className="t-pkg-list">
        {catalog.all().map((p) => (
          <article key={p.id} className="t-pkg">
            <div className="t-pkg-head">
              <h2>{p.name}</h2>
              <p className="t-price">{p.priceLabel()}</p>
            </div>
            <p className="t-pkg-summary">{p.summary}</p>
            <ul className="t-pkg-includes">
              {p.includes.map((i) => (
                <li key={i}>{i}</li>
              ))}
            </ul>
            <p className="t-note">Typical turnaround: {p.turnaround}</p>
            <Link to={`/quote?package=${p.id}`} className="t-btn t-btn-primary">
              Request a quote
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}
